import React from 'react';
import EditIcon from '../../common/assests/editicon.png';
import DeleteIcon from '../../common/assests/deleticon.png';
import { IconButton, TableCell, TableRow, useMediaQuery, useTheme } from '@mui/material';
import ReyLeaf from '../../common/assests/reyleafLogo.svg'
import configuration from '../../config/Config';

const NotificationRow = ({ row,index,ddeleteNotifcationelete,handleModal ,editData}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery('(max-width:480px)');

  return (
    <TableRow key={row?._id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
        <TableCell>{index+1}</TableCell>
      {/* <TableCell>{row?.srNo}</TableCell> */}
      <TableCell>{row?.sendTo||"-"}</TableCell>
      <TableCell>{row?.title||"-"}</TableCell>
      <TableCell>{row?.notificationType||"-"}</TableCell>
      <TableCell>
             <img
                src={
                row?.notificationPicture
                ? `${configuration.cdnFront}/${row?.notificationPicture}`
                : ReyLeaf
                 }
              style={{
                height: "50px",
                width: "50px",
                marginRight: "8px",
                borderRadius: "50%",
              }}
            />
      </TableCell>
      <TableCell>{row?.status||"-"}</TableCell>
      <TableCell>{row?.notificationDate ? new Date(row?.notificationDate).toLocaleDateString():"-"}</TableCell>
      <TableCell sx={{display:'flex',flexWrap:'wrap'}} >
        <IconButton onClick={editData}>
          
          <img src={EditIcon} alt="Edit" style={{ height: isSmallScreen ? '35px' : '45px', width: isSmallScreen ? '35px' : '45px' }} />
        </IconButton>
        <IconButton onClick={ddeleteNotifcationelete}>
        
          <img src={DeleteIcon} alt="Delete" style={{ height: isSmallScreen ? '35px' : '45px', width: isSmallScreen ? '35px' : '45px' }} />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default NotificationRow;
